import React from 'react';

export const UploadIcon: React.FC = () => (
  <svg
    width="64"
    height="57"
    viewBox="0 0 64 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54 28.3762C53.3448 28.4579 52.6773 28.5 52 28.5C43.1634 28.5 36 21.3366 36 12.5C36 10.5299 36.3561 8.64287 37.0074 6.8999H6C2.68629 6.8999 0 9.5862 0 12.8999V50.4999C0 53.8136 2.68629 56.4999 6 56.4999H48C51.3137 56.4999 54 53.8136 54 50.4999V28.3762ZM31.5156 28.7165C32.3854 27.1702 34.6055 27.1524 35.5 28.6846L45.379 45.6059C46.2727 47.1367 45.1685 49.0599 43.3959 49.0599H6.43017C4.60934 49.0599 3.51284 47.042 4.50349 45.5143L11.979 33.9858C12.8105 32.7036 14.6389 32.576 15.6403 33.7304L21.4228 40.3964C22.4639 41.5965 24.3799 41.4022 25.1588 40.0174L31.5156 28.7165ZM9.91993 19.3C9.91993 22.0394 12.1406 24.26 14.8799 24.26C17.6193 24.26 19.8399 22.0394 19.8399 19.3C19.8399 16.5607 17.6193 14.34 14.8799 14.34C12.1406 14.34 9.91993 16.5607 9.91993 19.3Z"
      fill="#2C4BFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52 24.5C58.6274 24.5 64 19.1274 64 12.5C64 5.87258 58.6274 0.5 52 0.5C45.3726 0.5 40 5.87258 40 12.5C40 19.1274 45.3726 24.5 52 24.5ZM59.3334 12.4999C59.3334 13.2363 58.7364 13.8333 58 13.8333H53.3334V18.5C53.3334 19.2364 52.7364 19.8333 52 19.8333C51.2637 19.8333 50.6667 19.2364 50.6667 18.5V13.8333H46.0001C45.2637 13.8333 44.6667 13.2363 44.6667 12.4999C44.6667 11.7635 45.2637 11.1666 46.0001 11.1666H50.6667L50.6666 6.49984C50.6666 5.76346 51.2636 5.1665 52 5.1665C52.7363 5.1665 53.3333 5.76346 53.3333 6.49984L53.3334 11.1666H58C58.7364 11.1666 59.3334 11.7635 59.3334 12.4999Z"
      fill="#2C4BFF"
    />
  </svg>
);
